import { useState } from "react";

import "../style/home.scss";

import LinkButton from "../components/LinkButton";

import BannerImg from "../img/homeImg.webp";
import faqImg from "../img/img3.webp";

import scImg1 from "../img/img6.webp";
import scImg2 from "../img/11.webp";
import scImg3 from "../img/8.webp";

export default function Home() {
  const [openIndex, setOpenIndex] = useState(0);

  const toggleQuestion = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  const faqData = [
    {
      id: 1,
      question: "Koliko traje efekat puder obrva?",
      answer:
        "Efekat traje od 1 do 2 godine, u zavisnosti od tipa kože, načina nege i životnih navika klijenta.",
    },
    {
      id: 2,
      question: "Da li je tretman bolan?",
      answer:
        "Ne, tretman je minimalno bolan jer se koristi anestetik u obliku kreme, što ga čini veoma podnošljivim.",
    },
    {
      id: 3,
      question: "Da li se puder obrve rade na svim tipovima kože?",
      answer:
        "Da, ali kod masne kože pigment može brže da izbledi, pa su potrebni češći dodaci boje (osvežavanje).",
    },
    {
      id: 4,
      question: "Kome se ne preporučuje tretman puder obrva?",
      answer: `Tretman puder obrva nije preporučljiv za:
      
      <ul>
  <li>Trudnice i dojilje</li>
  <li>Osobe sa dijabetesom tipa 1</li>
  <li>Osobe sa kožnim oboljenjima u predelu obrva (dermatitis, psorijaza, ekcem itd.)</li>
  <li>Osobe koje koriste lekove za razređivanje krvi (Aspirin, Warfarin...)</li>
  <li>Onkološki pacijenti (potrebna dozvola lekara)</li>
  <li>Osobe koje su nedavno imale hemijski piling ili laserski tretman</li>
  <li>Osobe sklone hipertrofičnim ožiljcima</li>
  <li>Osobe koje koriste određene lekove poput Roaccutane-a (treba sačekati najmanje 6 meseci nakon terapije)</li>
</ul>
      
        Ako niste sigurni da li ste kandidat za tretman, najbolje je da se posavetujete sa vašim
        lekarom pre donošenja odluke.`,
    },
  ];

  return (
    <>
      <section className="container banner home">
        <div className="wrapper p-30">
          <h1 data-aos="fade-right">
            Puder Obrve — Savršena <br /> Definicija i Prirodna Lepota
          </h1>

          <p data-aos="fade-right" data-aos-duration="2000">
            Istaknite svoju lepotu uz tehniku puder obrva koja pruža prirodan i
            dugotrajan izgled bez potrebe za svakodnevnim iscrtavanjem.
          </p>

          <div data-aos="fade-right" data-aos-duration="2500">
            <LinkButton link="/galerija-radova" buttonText="Pogledaj radove" />
          </div>

          <img data-aos="zoom-in" src={BannerImg} alt="Puder Obrve" />

          <div className="banner-list">
            <p>Prirodan izgled</p>
            <p>Dugotrajnost</p>
            <p>Štedi vreme</p>
            <p>Bezbolno</p>
          </div>
        </div>
      </section>

      <div className="wrapper faq p-30">
        <img
          data-aos="fade-right"
          src={faqImg}
          alt="Puder obrve | FAQ Najcesce postavljena pitanja"
        />

        <div className="faq-text">
          <h2>Najčešće postavljena pitanja</h2>

          {faqData.map((item, index) => (
            <div key={index}>
              <div>
                <div
                  data-aos="fade-left"
                  className="ques"
                  onClick={() => toggleQuestion(index)}
                >
                  <div className="ques_text">
                    <div className="id_ques">{item.id}</div>
                    <p>{item.question}</p>
                  </div>
                  <span>&#9660;</span>
                </div>

                {openIndex === index && (
                  <p
                    data-aos="fade-left"
                    className={`ans_text ${openIndex === index ? "open" : ""}`}
                    dangerouslySetInnerHTML={{ __html: item.answer }}
                  />
                )}
              </div>
            </div>
          ))}
          <br />
          <br />
          <div data-aos="fade-left">
            <LinkButton link='/najcesce-postavljena-pitanja' buttonText="Više pitanja" />
          </div>
        </div>
      </div>

      <div className="container success_box">
        <div className="wrapper p-30">
          <h2 data-aos="fade-right">
            <span style={{ color: "#A7A7A7" }}>Savršene obrve bez napora</span>{" "}
            <br /> i dugotrajan efekat
          </h2>

          <div className="success">
            <div data-aos="fade-right">
              <div className="check-box">
                <div className="check">&#10004;</div>
                <p>Savršen balans između suptilnosti i definicije.</p>
              </div>
              <div className="check-box">
                <div className="check">&#10004;</div>
                <p>Uvek sređene obrve bez dodatnog truda.</p>
              </div>
              <div className="check-box">
                <div className="check">&#10004;</div>
                <p>Istakni lepotu očiju na suptilan i elegantan način.</p>
              </div>
            </div>

            <div data-aos="fade-left">
              <div className="check-box">
                <div className="check">&#10004;</div>
                <p>Tehnika koja ne oštećuje prirodne dlačice.</p>
              </div>
              <div className="check-box">
                <div className="check">&#10004;</div>
                <p>Nežan izgled sa mekim prelazima i bez veštačkog efekta.</p>
              </div>
              <div className="check-box">
                <div className="check">&#10004;</div>
                <p>
                  Suptilno popunjavanje nedostataka za savršeno oblikovane
                  obrve.
                </p>
              </div>
            </div>
          </div>

          <div className="success_img">
            <img data-aos="zoom-in" src={scImg1} alt="Savršen balans između suptilnosti i definicije" />
            <img data-aos="zoom-in" src={scImg2} alt="Uvek sređene obrve bez dodatnog truda" />
            <img data-aos="zoom-in" src={scImg3} alt="Nežan izgled sa mekim prelazima i bez veštačkog efekta" />
          </div>
        </div>
      </div>
    </>
  );
}
